import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  InputLabel,
  Stack,
} from "@mui/material";
import {
  TextField,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { loadImageUrlById } from "../../../store/uploadFile";
import useGraphStore from "../../../store/zustandStore/graphZs";
import SelectFilter from "../../UI/SelectFilter";
import debounce from "../../../utils/debounce";

const NewImageDocModal = ({ isOpen, onClose, dataList, onSelect, year }) => {
  /// test image

  const dispatch = useDispatch();
  const { loadImageUrl } = useSelector((state) => state.uplaodFile);
  const {
    graphsZs,
    fetchGraphsZs,
    deleteGraphZs,
    setYear,
    setYearAndFetch,
    setSize,
    setSearchValueCurrent,
  } = useGraphStore();

  const [imageUrl, setImageUrl] = useState(null);

  /// test image

  const [search, setSearch] = useState("");
  const [newValue, setNewValue] = useState("");
  const [openNewLink, setOpenNewLink] = useState(false);
  const [filteredData, setFilteredData] = useState(dataList);
  const [anchorElForm, setAnchorElForm] = useState(null);
  const [searchValueServerForm, setSearchValueServerForm] = useState("");
  const searchState = useRef("");

  const openForm = Boolean(anchorElForm);

  const handleClickForm = (event) => {
    setAnchorElForm(event.currentTarget);
  };

  const handleCloseForm = () => {
    setAnchorElForm(null);
  };

  useEffect(() => {
    setSearch("");
    setNewValue("");
    setOpenNewLink(true);
    setFilteredData(dataList);
    setYear(year);
    fetchGraphsZs(); // fetchGraphsZs by year
  }, [isOpen]);

  useEffect(() => {
    setFilteredData(graphsZs);
  }, [graphsZs]);

  /// test image
  const handleOnloadImage = async (id) => {
    dispatch(loadImageUrlById({ id: id }));
  };

  useEffect(() => {
    setImageUrl(loadImageUrl);
  }, [loadImageUrl]);

  // test image

  // 🔁 Memoized debounced handler
  const debouncedSearch = React.useMemo(() => {
    return debounce((value) => {
      setSearchValueCurrent(value);
      setSize(20);
      fetchGraphsZs();
    }, 1000); // 300ms delay
  }, [setSearchValueCurrent]);

  const searchItems = (e) => {
    debouncedSearch(e.target.value);
    searchState.current.value = e.target.value;
  };

  React.useEffect(() => {
    // setSearchValueCurrent("");
    fetchGraphsZs();
  }, []);

  const onChangeNewValue = (e) => {
    const value = e.target.value;
    setNewValue(value);
  };

  const handleSelect = async (item) => {
    if (item?.file?.id) {
      // const cleanedImageId = item?.file?.id.replace(/\.png$/, "");
      await handleOnloadImage(item?.file?.id);
      const itemURL = { ...item, fileId: item?.file?.id, url: imageUrl };
      onSelect(itemURL);
    } else {
      const newItem = { ...item, fileId: item?.file?.id };
      onSelect(newItem);
    }
    onClose();
  };

  const handleAddNew = () => {
    // console.log("testtest",)
    // console.log("https://images.unsplash.com/photo-1523413651479-597eb2da0ad6");
    if (newValue.trim()) {
      const newData = { title: newValue.trim(), url: newValue.trim() };
      onSelect(newData);
      onClose();
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{
        zIndex: 1000,
        "& .MuiDialogContent-root": {
          padding: 2,
        },
        "& .MuiDialogActions-root": {
          padding: 2,
        },
        "& .MuiPaper-root.MuiDialog-paper": {
          minWidth: "600px",
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Zgjidh ose Shto URL
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Stack spacing={2} sx={{ mr: "10px" }}>
          <InputLabel required>Grfik</InputLabel>
          <SelectFilter
            textfield
            maxWidth={"100%"}
            // disabledfilter={!state.reportingUnitId}
            name="formulaId"
            id="formulaId"
            label="Grafik"
            placeholder="Kërko Grafik"
            noOptionsText="Nuk ka Grafik"
            // value={state.formulaId}
            onClick={handleClickForm}
            source={graphsZs}
            open={openForm}
            anchorEl={anchorElForm}
            onClickAway={handleCloseForm}
            onClose={(event, reason) => {
              if (reason === "escape") {
                handleCloseForm();
              }
            }}
            onChange={(event, newValue, reason) => {
              if (
                event.type === "keydown" &&
                event.key === "Backspace" &&
                reason === "removeOption"
              ) {
                return;
              }
              handleSelect(newValue);
              handleCloseForm();
            }}
            zIndexPopper={10000}
            sx={{ zIndex: "2000" }}
            onchangesearch={searchItems}
            inputRef={searchState}
          ></SelectFilter>
        </Stack>
      </DialogContent>
      {/* <DialogContent>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Kerko dhe zgjidh nga lista..."
          value={search}
          onChange={handleSearch}
          margin="dense"
          sx={{
            "& .MuiInputBase-root.MuiOutlinedInput-root.MuiOutlinedInput-root fieldset":
              {
                border: "2px solid #3B376C",
              },
          }}
        />
        <List>
          {filteredData.map((item) => (
            <ListItem key={item} disablePadding>
              <ListItemButton onClick={() => handleSelect(item)}>
                <ListItemText primary={item.title} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent> */}
      <Box
        sx={{
          padding: 1,
          borderTop: "1px solid black",
          display: "flex",
          justifyContent: "end",
          cursor: "pointer",
        }}
        onClick={() => setOpenNewLink(!openNewLink)}
      >
        {openNewLink ? "🔽 Shto Foto te Re " : "🔼 Mbyll"}
      </Box>
      {!openNewLink && (
        <DialogActions sx={{ display: "flex", flexDirection: "column" }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Link i ri"
            value={newValue}
            onChange={onChangeNewValue}
            margin="dense"
            sx={{
              "& .MuiInputBase-root.MuiOutlinedInput-root.MuiOutlinedInput-root fieldset":
                {
                  border: "1px solid #3B376C",
                },
            }}
          />
          <Button
            onClick={handleAddNew}
            variant="contained"
            color="primary"
            fullWidth
          >
            Shto
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default NewImageDocModal;
